export * from "./pages";

// TODO: these exports can be removed once the feature library is implemented on all brands
export * from "./components/CancelSubscriptionButton";
export * from "./components/MySubscription/Headers";
export { intl as preselectorQuizIntl } from "./pages/subscription/preferences/PreselectorQuizPage.Intl";
export { intl as yourMealboxIntl } from "./components/MySubscription/YourMealbox.Intl";
export { intl as myAccountContactUsPageIntl } from "./pages/MyAccountContactUsPage.Intl";
export { intl as paymentMethodPageIntl } from "./pages/payment-method/MyAccountPaymentMethodPage.Intl";
export { intl as mySubscriptionHeadersIntl } from "./components/MySubscription/Headers.Intl";
export { intl as giftCardSuccessIntl } from "./pages/giftcard/GiftCardSuccessPage.Intl";
export { intl as contactPreferencesIntl } from "./components/CommunicationPreferencesForm.Intl";
export { intl as specialItemsIntl } from "./pages/subscription/standalone/SubscriptionStandalonePage.Intl";
export { intl as specialItemsConfirmationIntl } from "./pages/subscription/standalone/SubscriptionConfirmationPage.Intl";
export { intl as paymentMethodIntl } from "./pages/payment-method/MyAccountPaymentMethodPage.Intl";
export { intl as personalInformationIntl } from "./pages/account-information/MyAccountAccountInformationPage.Intl";
export { intl as changePasswordIntl } from "./pages/account-information/MyAccountChangePasswordPage.Intl";
export { intl as contactUsPageIntl } from "./pages/MyAccountContactUsPage.Intl";
export { intl as deliveryPageIntl } from "./pages/delivery-information/MyAccountDeliveryInformationPage.Intl";
export { intl as giftCardIntl } from "./components/GiftcardOrderForm.Intl";
export * from "./types";
